import RelatedcoursesModule from './containers/relatedcoursesModule'

export {default as RelatedcoursesModuleLayout} from './components/relatedcoursesModuleLayout'

export default RelatedcoursesModule
